import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ProcessTimeStatusEnum } from '../../enum';
import { CoreStatus } from '../CoreStatus';

interface ProcessTimeStatusProps {
  value: ProcessTimeStatusEnum;
}

const ProcessTimeStatusColor = {
  [ProcessTimeStatusEnum.Processed]: '#22C55E',
  [ProcessTimeStatusEnum.Incomplete]: '#D19500',
  [ProcessTimeStatusEnum.Pending]: '#737373',
};
export const ProcessTimeStatus: FC<ProcessTimeStatusProps> = ({ value }) => {
  const { t } = useTranslation('status', { keyPrefix: 'processTime' });

  return (
    <CoreStatus
      value={t(value, value)}
      backgroundColor={ProcessTimeStatusColor[value]}
    />
  );
};
